import React, { useState, useEffect } from "react";
import { setSimulateurObject } from "../../../actions/simulateur.action";
import { useDispatch } from "react-redux";
import { styles } from "../../../stylesheets/simulateurs.css";
import "../../../stylesheets/simulateursBis.css";
import TextSimulateurTitle from "../../../components/texts/text.simulateurTitle";
import TextfieldNumber from "../../../components/textfields/textfield.number";
import SelectCommon from "../../../components/selects/select.common";
import TextfieldRemarques from "../../../components/textfields/textfiel.remarques";
import { ToolTipPerso } from "../../../components/selects/tooltip_perso";

// Calcul d'un montant d'usufruit
// Id simulateur 105

function Simulateur_105(props) {
  const dispatch = useDispatch();

  const [nombre_donateurs, setDonateur] = useState(0);
  const [age_usufruitier_1, setUsu1] = useState(0);
  const [age_usufruitier_2, setUsu2] = useState(0);
  const [valeur_bien_1, setBien1] = useState(0);
  const [valeur_bien_2, setBien2] = useState(0);
  const [typeUsufruit, setTypeUsufruit] = useState(0);
  const [dureeUsufruit, setDureeUsufruit] = useState(0);
  useEffect(() => {
  if (typeUsufruit === 1) {
    setDonateur(0);
    setUsu1(0);
    setUsu2(0);
    setBien1(0);
    setBien2(0);
    
    dispatch(
      setSimulateurObject({
        simulateurid: props.simulateur.id,
        inputs: {
          type_usufruit: 1,
          nombre_donateurs: null,
          age_usufruitier_1: null,
          age_usufruitier_2: null,
          valeur_bien_2: null,
        },
      })
    );
  }

  if (typeUsufruit === 0) {
    setDureeUsufruit(0);
    setBien1(0);  
    setBien2(0);  
    dispatch(
      setSimulateurObject({
        simulateurid: props.simulateur.id,
        inputs: {
          type_usufruit: 0,
          duree_usufruit: null,
          age_usufruitier_1: null,
          valeur_bien_1: null,
          valeur_bien_2: null, 
        },
      })
    );
  }
}, [typeUsufruit, dispatch, props.simulateur.id]);

  const typeUsufruitOptions = [
    { id: 0, name: "Viager" },
    { id: 1, name: "À durée fixe" },
  ];

  const handleChange = async (setter, value) => {
    if (setter === setTypeUsufruit) {
      setTypeUsufruit(parseInt(value));
    } else {
      setter(value);
    }
    setInRedux(setter, value);
  };

  const handleChangeRemarque = async (value) => {
    localStorage.setItem("remarque", value);
  };

  function setInRedux(setter, value) {
    if (props.isParent) {
      let object = {
        simulateurid: props.simulateur.id,
        inputs: {},
      };
      Object.assign(object.inputs, {
        type_usufruit: typeUsufruit,
      });
      if (typeUsufruit === 1) {
        Object.assign(object.inputs, {
          type_usufruit: 1,
          duree_usufruit:
            setter === setDureeUsufruit ? parseInt(value) : parseInt(dureeUsufruit),
          valeur_bien_1:
            setter === setBien1 ? parseInt(value) : parseInt(valeur_bien_1),
          age_usufruitier_1:
            setter === setUsu1 ? parseInt(value) : parseInt(age_usufruitier_1),
        });
        dispatch(setSimulateurObject(object));
        return;
      }


      if (setter === setDonateur && typeUsufruit === 0) {
        Object.assign(object["inputs"], { nombre_donateurs: parseInt(value) });
        Object.assign(object["inputs"], { age_usufruitier_1: parseInt(age_usufruitier_1) });
        Object.assign(object["inputs"], { age_usufruitier_2: parseInt(age_usufruitier_2) });
        Object.assign(object["inputs"], { valeur_bien_1: parseInt(valeur_bien_1) });
        Object.assign(object["inputs"], { valeur_bien_2: parseInt(valeur_bien_2) });
      }

      if (setter === setUsu1 && typeUsufruit === 0) {
        Object.assign(object["inputs"], { nombre_donateurs: parseInt(nombre_donateurs) });
        Object.assign(object["inputs"], { age_usufruitier_1: parseInt(value) });
        Object.assign(object["inputs"], { age_usufruitier_2: parseInt(age_usufruitier_2) });
        Object.assign(object["inputs"], { valeur_bien_1: parseInt(valeur_bien_1) });
        Object.assign(object["inputs"], { valeur_bien_2: parseInt(valeur_bien_2) });
      }

      if (setter === setUsu2 && typeUsufruit === 0) {
        Object.assign(object["inputs"], { nombre_donateurs: parseInt(nombre_donateurs) });
        Object.assign(object["inputs"], { age_usufruitier_1: parseInt(age_usufruitier_1) });
        Object.assign(object["inputs"], { age_usufruitier_2: parseInt(value) });
        Object.assign(object["inputs"], { valeur_bien_1: parseInt(valeur_bien_1) });
        Object.assign(object["inputs"], { valeur_bien_2: parseInt(valeur_bien_2) });
      }

      if (setter === setBien1 && typeUsufruit === 0) {
        Object.assign(object["inputs"], { nombre_donateurs: parseInt(nombre_donateurs) });
        Object.assign(object["inputs"], { age_usufruitier_1: parseInt(age_usufruitier_1) });
        Object.assign(object["inputs"], { age_usufruitier_2: parseInt(age_usufruitier_2) });
        Object.assign(object["inputs"], { valeur_bien_1: parseInt(value) });
        Object.assign(object["inputs"], { valeur_bien_2: parseInt(valeur_bien_2) });
      }

      if (setter === setBien2 && typeUsufruit === 0) {
        Object.assign(object["inputs"], { nombre_donateurs: parseInt(nombre_donateurs) });
        Object.assign(object["inputs"], { age_usufruitier_1: parseInt(age_usufruitier_1) });
        Object.assign(object["inputs"], { age_usufruitier_2: parseInt(age_usufruitier_2) });
        Object.assign(object["inputs"], { valeur_bien_1: parseInt(valeur_bien_1) });
        Object.assign(object["inputs"], { valeur_bien_2: parseInt(value) });
      }

      dispatch(setSimulateurObject(object));
    } else {
      // process child simu
    }
  }

  const nbDonateur = [
    {
      id: 1,
      name: "Une personne",
    },
    {
      id: 2,
      name: "Deux personnes",
    },
  ];

  return (
    <div style={styles.container}>
      <div className="cardSimulateur">
        <TextSimulateurTitle title={props.simulateur.name} currentSimuId={props.simulateur.id} />

        <TextfieldRemarques handleChange={handleChangeRemarque} />
        <div className="cardRow">
          <div style={styles.cardElemVerticalyCenter}>
            De quel type d'usufruit s'agit-il ?
          </div>
          <SelectCommon
            items={typeUsufruitOptions}
            defaultValue={0}
            nameField={"name"}
            optionValue={"id"}
            handleChange={handleChange}
            setter={setTypeUsufruit}
          />
        </div>

        {/* cas de l'usufruit à durée fixe */}
         {typeUsufruit === 1 && (
          <>
          <div className="cardRow">
            <div style={styles.cardElemVerticalyCenter}>
              Indiquer la durée de l'usufruit
              <ToolTipPerso
                title={
                  "Si l'acquéreur est une personne morale, l'usufruit ne peut durer plus de trente ans (article 619 du Code Civil). Attention, la valeur de l'usufruit à durée fixe ne peut pas excéder celle de l'usufruit viager."
                }
              />
            </div>
            <TextfieldNumber
              handleChange={handleChange}
              type={"number"}
              placeholder={"Durée en années"}
              setter={setDureeUsufruit}
            />
          </div>
          <div className="cardRow">
            <div style={styles.cardElemVerticalyCenter}>Indiquer l'âge de l'usufruitier actuel (vendeur ou donateur): </div>
            <TextfieldNumber
              handleChange={handleChange}
              type={"number"}
              placeholder={"Indiquer l'âge"}
              setter={setUsu1}
            />
          </div>
          <div className="cardRow">
            <div style={styles.cardElemVerticalyCenter}>
              Quelle est la valeur du bien ?
            </div>
            <TextfieldNumber
              handleChange={handleChange}
              type={"number"}
              placeholder={"Indiquer la valeur du bien"}
              setter={setBien1}
            />
          </div>
          </>
        )}

        {/* cas de l'usufruit viager */}
        {typeUsufruit === 0 && (
        <>
        <div className="cardRow">
          <div style={styles.cardElemVerticalyCenter}>Y a-t-il une ou deux personnes ?</div>
          <SelectCommon
            items={nbDonateur}
            defaultValue={1}
            nameField={"name"}
            optionValue={"id"}
            handleChange={handleChange}
            setter={setDonateur}
          />
        </div>

        <div className="cardRow">
          {parseInt(nombre_donateurs) === 2 ? (
            <div style={styles.cardElemVerticalyCenter}>Indiquer l’âge de la personne 1 :</div>
          ) : (
            <div style={styles.cardElemVerticalyCenter}>Indiquer l’âge de la personne :</div>
          )}
          <TextfieldNumber
            handleChange={handleChange}
            type={"number"}
            placeholder={"Indiquer l'age"}
            setter={setUsu1}
          />
        </div>

        {parseInt(nombre_donateurs) === 2 ? (
          <div className="cardRow">
            <div style={styles.cardElemVerticalyCenter}>Indiquer l’âge de la personne 2 :</div>
            <TextfieldNumber
              handleChange={handleChange}
              type={"number"}
              placeholder={"Indiquer l'age"}
              setter={setUsu2}
            />
          </div>
        ) : (
          <></>
        )}

        <div className="cardRow">
          <div style={styles.cardElemVerticalyCenter}>
            {parseInt(nombre_donateurs) === 2 ? (
              <>Quelle est la valeur donnée par la personne 1 ? </>
            ) : (
              <>Quelle est la valeur donnée par la personne ? </>
            )}
          </div>
          <TextfieldNumber
            handleChange={handleChange}
            type={"number"}
            placeholder={"Indiquer la valeur"}
            setter={setBien1}
          />
        </div>

        {parseInt(nombre_donateurs) === 2 ? (
          <div className="cardRow">
            <div style={styles.cardElemVerticalyCenter}>Quelle est la valeur donnée par la personne 2 ?</div>
            <TextfieldNumber
              handleChange={handleChange}
              type={"number"}
              placeholder={"Indiquer la valeur"}
              setter={setBien2}
            />
          </div>
        ) : (
          <></>
          
                )}
        </>
        )}
      </div>
    </div>
  );
}


export default Simulateur_105;